import { Component } from '@angular/core';
import {MainScreenComponent} from "./main-screen/main-screen.component";

@Component({
  selector: 'app-app-documents',
  standalone: true,
  imports: [
    MainScreenComponent
  ],
  templateUrl: './app-documents.component.html',
  styleUrl: './app-documents.component.css'
})
export class AppDocumentsComponent {

}
